import api from './api';

export const tableService = {
  async getTablesAndColumns(): Promise<any[]> {
    try {
      console.log('🔍 [FRONTEND] getTablesAndColumns chamada');
      console.log('📌 Token:', localStorage.getItem('token'));
      
      const response = await api.get('/user-dataset-history/tables');  // ← ADICIONEI /api
      
      console.log('✅ [FRONTEND] Resposta status:', response.status);
      console.log('✅ [FRONTEND] Resposta data:', response.data);
      
      return response.data.data;
    } catch (error: any) {
      console.error('❌ [FRONTEND] Erro:', error.message);
      console.error('❌ [FRONTEND] Resposta do erro:', error.response?.data);
      throw error;
    }
  },

  async getTableAndColumns(tableName: string): Promise<any> {
    try {
      console.log(`🔍 [FRONTEND] getTableAndColumns chamada para: ${tableName}`);
      
      const response = await api.get(`/user-dataset-history/tables/${tableName}`);  // ← ADICIONEI /api
      
      console.log('✅ [FRONTEND] Resposta status:', response.status);
      console.log('✅ [FRONTEND] Resposta data:', response.data);
      
      return response.data.data;
    } catch (error: any) {
      console.error(`❌ [FRONTEND] Erro ao buscar ${tableName}:`, error.message);
      console.error('❌ [FRONTEND] Resposta do erro:', error.response?.data);
      throw error;
    }
  }
};